import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";
import { forgotPassword } from "../api/auth";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setError("");
    setLoading(true);
    try {
      await forgotPassword({ email });
      navigate("/reset-password-sent", { state: { email } });
    } catch (err) {
      setError(err.message || "خطا در ارسال ایمیل. دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="touch-wrapper" dir="rtl">
      {error && (
        <div className="touch-toast">
          <div>
            <div className="touch-toast-title">خطا در بازیابی</div>
            <p className="touch-toast-body">{error}</p>
          </div>
        </div>
      )}
      <div className="touch-left">
        <div className="touch-logo-wrapper">
          <img
            src="/images/touch-prop-logo.png"
            alt="Touch Prop Logo"
            className="touch-logo"
          />
        </div>

        <div className="touch-reset-container">
          <form className="touch-reset-card" onSubmit={handleSubmit}>
            <h1 className="touch-reset-title">بازیابی رمز عبور</h1>
            <div className="touch-reset-label">ایمیل ثبت‌شده را وارد کن</div>
            <div className="touch-input-card touch-reset-input-card">
              <input
                type="email"
                className="touch-input touch-reset-input"
                placeholder="ایمیل"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="touch-input-divider" />
              <div className="touch-input-icon">
                <span className="touch-input-icon-text">@</span>
              </div>
            </div>

            <button
              type="submit"
              className="touch-primary-btn touch-reset-btn"
              disabled={loading}
            >
              {loading ? "در حال ارسال..." : "ارسال لینک/کد بازیابی"}
            </button>
          </form>

          <button
            type="button"
            className="touch-back-link"
            onClick={() => navigate("/login")}
          >
            <span className="touch-back-icon">{"<"}</span>
            بازگشت به ورود
          </button>
        </div>
      </div>

      <div className="touch-right">
        <img
          src="/images/fingerprint-pattern.png"
          alt="Fingerprint"
          className="touch-fingerprint"
        />
        <div className="touch-right-overlay">
          <div className="touch-hero-text">
            <h2 className="touch-hero-title">تاچ پراپ ، لمس ثروت بی کران</h2>
            <p className="touch-hero-body">
              مسیر معامله‌گری هوشمند از همین‌جا شروع می‌شه
            </p>
            <div className="touch-dots">
              <span className="touch-dot touch-dot-active" />
              <span className="touch-dot" />
              <span className="touch-dot" />
              <span className="touch-dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
